import { useContext } from 'react'
import { AuthContext } from 'data/context/auth-context'

export function UseAuth() { return useContext(AuthContext) }